export enum SortTypes {
  NAME = 'Name',
  ID = 'ID',
  STUDIO = 'Studio',
}
